export default __webpack_public_path__ + "static/media/Goldplay-Regular.a83bb954.otf";